import React from 'react';
import styles from './EnergyKwhMini.module.scss';

export interface EnergyKwhMiniProps {
  value: number | null | undefined;
  tooltip?: string;
}

export default function EnergyKwhMini({ value, tooltip }: EnergyKwhMiniProps) {
  const isNA = value === null || value === undefined || Number.isNaN(value);
  const color = isNA ? '#d1d5db' : '#059669';
  const formatted = isNA ? 'NA' : value.toFixed(2);

  return (
    <div className={styles.container} title={tooltip}>
      <span className={styles.value} style={{ color }}>
        {formatted}
      </span>
      {!isNA && (
        <span className={styles.unit} style={{ color }}>
          {' '}kWh
        </span>
      )}
    </div>
  );
}
